module.exports = __webpack_public_path__ + "4fe21f557e998c1a42c3312fe286d900.png";